import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToggleSidebarService {
  private readonly toggleSidebarBehaviorSubject: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );

  get toggleSidebar$(): Observable<boolean> {
    return this.toggleSidebarBehaviorSubject.asObservable();
  }

  get toggleSidebar(): boolean {
    return this.toggleSidebarBehaviorSubject.value;
  }

  constructor() {}

  set(isToggled: boolean) {
    this.toggleSidebarBehaviorSubject.next(isToggled);
  }
}
